import { StorageService } from './../services/storage.service';
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { Config } from '@shared/config';

@Pipe({
  name: 'formattedDate',
})
export class FormattedDatePipe implements PipeTransform {
  constructor(public storage: StorageService) {}
  transform(value: any, args?: any): any {
    if (value === null) {
      return '-';
    }
    if (args === 'fulltime') {
      return moment(value, Config.DATE_FORMAT_BACKEND, this.storage.getLang()).format(
        Config.DATE_FORMAT_FRONTEND_FULL
      );
    }
    return moment(value, Config.DATE_FORMAT_BACKEND, this.storage.getLang()).format(
      Config.DATE_FORMAT_FRONTEND
    );
  }
}
